import { render, staticRenderFns } from "./testItemAction.vue?vue&type=template&id=02a0facc&scoped=true"
import script from "./testItemAction.vue?vue&type=script&lang=js"
export * from "./testItemAction.vue?vue&type=script&lang=js"
import style0 from "./testItemAction.vue?vue&type=style&index=0&id=02a0facc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a0facc",
  null
  
)

export default component.exports